'use client'

import clsx from 'clsx'
import React from 'react'

const ScrollTo = (props: {
    target?: string
    className?: string
    offset?: number
    behavior?: ScrollBehavior
    children: React.ReactNode
}) => {
    const handleClick = () => {
        if (!props.target) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
            return
        }
        const el = document.querySelector(props.target)
        if (!el) return
        el.scrollIntoView({
            behavior: props.behavior ?? 'smooth',
            block: 'center'
        })
    }

    return (
        <button
            onClick={handleClick}
            className={clsx('floating-btn', props.className)}
        >
            {props.children}
        </button>
    )
}

export default ScrollTo
